(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$stickyStateProvider', '$urlRouterProvider'];

    function stateConfig($stateProvider, $stickyStateProvider, $urlRouterProvider ) {
        $stateProvider
        .state('port', {
            // parent: 'entity',
            parent: 'entity',
            url: '/port?page&sort&search',
            sticky: true,
            data: {
                authorities: ['ROLE_ADMIN','ROLE_TUI'],
                pageTitle: 'ccsTrApp.port.home.title',
                title: 'Ports'
            },
            views: {
                // 'content@': {
                'port@': {
                    templateUrl: 'app/entities/port/ports.html',
                    controller: 'PortController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('port');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('port-detail', {
            // parent: 'entity',
            parent: 'app',
            url: '/port/{id}',
            sticky: true,
            data: {
                authorities: ['ROLE_ADMIN','ROLE_TUI'],
                pageTitle: 'ccsTrApp.port.detail.title',
                title: 'Detail'
            },
            views: {
                // 'content@': {
                'port-detail@': {
                    templateUrl: 'app/entities/port/port-detail.html',
                    controller: 'PortDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('port');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Port', function($stateParams, Port) {
                    return Port.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'port',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('port-detail.edit', {
            // parent: 'port-detail',
            parent: 'app',
            // url: '/detail/edit',
            url: '/port/detail/edit',
            sticky: false,
            data: {
                authorities: ['ROLE_ADMIN','ROLE_TUI']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/port/port-dialog.html',
                    controller: 'PortDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Port', function(Port) {
                            return Port.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('port.new', {
            parent: 'app',
            sticky: false,
            data: {
                authorities: ['ROLE_ADMIN','ROLE_TUI']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/port/port-dialog.html',
                    controller: 'PortDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                createdOn: new Date(),
                                createdBy: 'admin',
                                modifiedOn: new Date(),
                                modifiedBy: 'admin',
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('port', null, { reload: true });
                }, function() {
                    $state.go('port');
                });
            }]
        })
        .state('port.edit', {
            parent: 'app',
            url: '/port/{id}/edit',
            sticky: false,
            data: {
                authorities: ['ROLE_ADMIN','ROLE_TUI']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/port/port-dialog.html',
                    controller: 'PortDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Port', function(Port) {
                            return Port.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('port', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('port.delete', {
            // parent: 'port',
            parent: 'app',
            // url: '/{id}/delete',
            url: '/port/{id}/delete',
            sticky: false,
            data: {
                authorities: ['ROLE_ADMIN','ROLE_TUI']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/port/port-delete-dialog.html',
                    controller: 'PortDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Port', function(Port) {
                            return Port.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('port', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });

        $stickyStateProvider.enableDebug( true );

    }

})();
